import type { EphemeralUserAtSerialized, EphemeralUserDisconnectedSerialized } from '@playq/octopus-notifications';

import { Class, CouponsClass } from '/common/models/enums';

export type SetModulePayload = Partial<Omit<ICurrentModuleState, 'onlineUsers'>>;
export type ProcessModuleUserPayload = EphemeralUserAtSerialized;
export type DeleteModuleUser = EphemeralUserDisconnectedSerialized;

export type ModuleUser = EphemeralUserAtSerialized & {
  userID: NonNullable<EphemeralUserAtSerialized['userID']>;
  userName: NonNullable<EphemeralUserAtSerialized['userName']>;
  appID: NonNullable<EphemeralUserAtSerialized['appID']>;
  appName: NonNullable<EphemeralUserAtSerialized['appName']>;
};

interface ICurrentModuleState {
  moduleClass: Class | CouponsClass | undefined;
  linkToTheLastModulePage?: string;
  entityId?: string;
  disableUserAtNotifications?: boolean;
  onlineUsers: Record<string, ModuleUser>;
  isSpaceLessModule?: boolean;
}

export const initialCurrentState: ICurrentModuleState = {
  moduleClass: undefined,
  entityId: undefined,
  disableUserAtNotifications: undefined,
  onlineUsers: {},
  isSpaceLessModule: undefined,
};
